module.exports = __webpack_public_path__ + "img/repay.c1e20b98.svg";